import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/TransformerRectifierSetsESPHero-bg.webp";
import ArticleImg        from "../../asset/images/news/news-7.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .trs { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .trs-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden; 
  }
  .trs-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .trs-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .trs-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .trs-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 520px;
  }
  .trs-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .trs-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .trs-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .trs-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .trs-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .trs-bc-item:hover { color: #EB2019; }
  .trs-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .trs-bc-sep img { width: 24px; height: 24px; display: block; }
  .trs-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .trs-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .trs-main-section { padding: 80px 0 120px 0; }
  .trs-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .trs-article { flex: 1; min-width: 0; }

  .trs-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .trs-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .trs-meta-item:last-child { border-right: none; padding-right: 0; }
  .trs-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .trs-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .trs-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .trs-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .trs-article-body p { margin-bottom: 15px; }
  .trs-article-body p:last-child { margin-bottom: 0; }

  /* Bold headings */
  .trs-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 5px 0 15px 0; line-height: 160%; display: block;
  }

  /* Bullet list */
  .trs-article-body ul {
    list-style: none; margin: 0 0 15px 0; padding: 0;
    display: flex; flex-direction: column; gap: 8px;
  }
  .trs-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .trs-article-body ul li::before {
    content: '•'; color: #202020;
    font-size: 16px; line-height: 160%; flex-shrink: 0;
  }
  .trs-article-body ul li > span { flex: 1; }

  .trs-article-body strong { font-weight: 600; color: #202020; }

  .trs-red-link { color: #EB2019; text-decoration: underline; }
  .trs-red-link:hover { opacity: 0.8; }

  /* Hashtags */
  .trs-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .trs-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .trs-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .trs-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .trs-nav-btn:hover { color: #EB2019; }
  .trs-nav-btn img { width: 40px; height: 40px; display: block; }

  .trs-share-icons { display: flex; align-items: center; gap: 20px; }
  .trs-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .trs-share-icon:hover { opacity: 0.85; }
  .trs-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .trs-sidebar { flex: 0 0 475px; }
  .trs-sidebar-block { margin-bottom: 60px; }
  .trs-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .trs-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .trs-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .trs-recent-item:hover .trs-recent-title { color: #EB2019; }
  .trs-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .trs-recent-body { flex: 1; min-width: 0; }
  .trs-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .trs-social-icons { display: flex; align-items: center; gap: 30px; }
  .trs-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .trs-social-icon:hover { opacity: 0.8; }
  .trs-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .trs-hero             { height: 350px; }
    .trs-hero-content     { padding: 0 32px; }
    .trs-hero-title       { font-size: 30px; }
    .trs-hero-divider     { width: 100%; max-width: 479px; }
    .trs-breadcrumb       { padding: 24px 0 0 0; }
    .trs-breadcrumb-inner { padding: 0 32px; }
    .trs-inner            { padding: 0 32px; }
    .trs-main-section     { padding: 48px 0 60px 0; }
    .trs-main-row         { flex-direction: column; gap: 48px; }
    .trs-sidebar          { flex: none; width: 100%; }
    .trs-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .trs-hero             { height: 360px; }
    .trs-hero-content     { padding: 0 16px; }
    .trs-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .trs-hero-divider     { width: 100%; }
    .trs-hero-subtitle    { font-size: 14px; }
    .trs-breadcrumb       { padding: 30px 0 0 0; }
    .trs-breadcrumb-inner { padding: 0 16px; }
    .trs-bc-item          { font-size: 14px; gap: 14px; }
    .trs-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .trs-bc-sep img       { width: 22px; height: 22px; }
    .trs-inner            { padding: 0 16px; }
    .trs-main-section     { padding: 30px 0 60px 0; }
    .trs-main-row         { flex-direction: column; gap: 60px; }
    .trs-sidebar          { flex: none; width: 100%; }
    .trs-article-title    { font-size: 20px; margin-bottom: 15px; }
    .trs-sidebar-title { font-size: 20px; }
    .trs-article-body     { font-size: 14px; }
    .trs-meta-item        { font-size: 14px; }
    .trs-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .trs-h2               { font-size: 16px; margin: 20px 0 15px 0; }
    .trs-nav-btn img      { width: 24px; height: 24px; }
    .trs-nav-btn          { font-size: 14px; }
    .trs-share-icon img   { width: 34px; height: 34px; }
    .trs-hashtags {margin-top: 20px;}
.trs-bottom-nav { gap:20px;}

  }
`;

const recentPosts = [
  {
    img: RecentImg1,
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    slug: "battery-formation-testing-enabling-rise-ev-energy-storage-manufacturing",
  },
  {
    img: RecentImg2,
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    slug: "next-gen-esp-power-supplies-upgrades-sustainability-industrial-air-pollution-control",
  },
  {
    img: RecentImg3,
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    slug: "green-hydrogen-power-electronics-ador-powertron-forefront-electrolyzer-rectifier-setups",
  },
  {
    img: RecentImg4,
    title: "Transformer Bushings: Types & Importance",
    slug: "transformer-bushings-types-importance",
  },
];

export default function TransformerRectifierSetsESP() {
  return (
    <div className="trs">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="trs-hero">
        <img className="trs-hero-bg" src={HeroBgImg} alt="Transformer Rectifier Sets ESP Hero" />
        <div className="trs-hero-overlay" />
        <div className="trs-hero-content">
          <h1 className="trs-hero-title">
            How Transformer-Rectifier Sets Power Efficient-Electrostatic Precipitators
          </h1>
          <hr className="trs-hero-divider" />
          <p className="trs-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="trs-breadcrumb" aria-label="Breadcrumb">
        <div className="trs-breadcrumb-inner">
          <a href="/" className="trs-bc-item">Home</a>
          <span className="trs-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="trs-bc-item">News &amp; Updates</a>
          <span className="trs-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="trs-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="trs-main-section">
        <div className="trs-inner">
          <div className="trs-main-row">

            {/* ── ARTICLE ── */}
            <article className="trs-article">

              {/* Meta bar */}
              <div className="trs-meta-bar">
                <span className="trs-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="trs-meta-item"><img src={CalendarIcon} alt="date" /> June 17, 2025</span>
                <span className="trs-meta-item"><img src={ClockIconImg} alt="time" /> 11:34 am</span>
                <span className="trs-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="trs-article-title">
                How Transformer-Rectifier Sets Power Efficient-Electrostatic Precipitators
              </h1>

              {/* Body */}
              <div className="trs-article-body">

                <p>Industrial pollution control is a trending topic among factories that manage to keep their emissions in check. And the one doing the heavy lifting behind the scenes is the Electrostatic Precipitator (ESP).</p>

                <p>In this blog, we will break down how T/R units play a significant role in making ESPs more energy-efficient.</p>

                <p><strong>Let's dive in!</strong></p>

                {/* Article image */}
                <img className="trs-article-img" src={ArticleImg} alt="Transformer Rectifier Sets" />

                <span className="trs-h2"> 1. Turning AC to High Voltage DC</span>

                <p>An ESP acts like a cleaner for exhaust fumes, working with a powerful DC electric field. That's where the <strong>transformer rectifier</strong> comes in, taking low-voltage AC and converting it into high-voltage DC that ranges up to 200 kV.</p>

                <p>It matters a lot because the DC field charges the dusty particles, pulling them out of the air and preventing pollution escape.</p>

                <span className="trs-h2">2. High-Frequency Power</span>

                <p>Advancements in ESP systems have introduced a smarter option for <strong>high-frequency (HF) power supplies</strong>, delivering a more stable and consistent voltage. This results in better voltage control, lower ripple, and faster spark handling.</p>

                <span className="trs-h2">3. Customizing for Efficiency</span>

                <p>Your electrostatic precipitator can't run efficiently with a generic <strong>transformer rectifier</strong> setup. The input voltage to the system varies for every setup; it could be 380 V, 415 V, or even 690 V.</p>

                <p>That's why transformer rectifier units need to be customised according to some fundamental factors:</p>

                <ul>
                  <li><span>Voltage and current ratings</span></li>
                  <li><span>Cooling mechanisms</span></li>
                  <li><span>Insulation class and tank construction</span></li>
                  <li><span>Surge protection features</span></li>
                </ul>

                <span className="trs-h2">4. Upgrade Your ESP Without Replacing Everything</span>

                <p>Is your ESP setup too outdated to meet the latest performance standards? Planning to replace? Don't worry; you don't always have to start from scratch. Retrofitting is one of the most significant advantages of modern <strong>transformer rectifier</strong> technology, enabling you to upgrade your ESP's efficiency.</p>

                <p>This module enhances the performance of your current T/R set by stabilizing voltage, improving spark control, and reducing ripple.</p>

                <span className="trs-h2">5. How Better Power Improves Your ESP</span>

                <p>When a transformer rectifier setup works with high-frequency control and properly matched components, measurable benefits can be seen in ESP's performance. You can expect higher collection efficiency, lower energy consumption, fewer shutdowns and faults, and improved power factor.</p>

                <span className="trs-h2">Final thoughts</span>

                <p>Your <strong>ESP</strong> can't perform well without a reliable power backbone. If you are struggling with patchy dust collection and energy costs, then your <strong>transformer rectifier</strong> setup is the missing link.</p>

                <p>Thinking, where do I start? — that's where <strong>Ador Powertron</strong> comes in.<br />
                With decades of expertise in power electronics, Ador is recognized for delivering transformer rectifier sets, innovative high-frequency systems, and advanced controllers that seamlessly integrate into existing setups. Whether you are looking for a new installation or a performance-driven retrofit, Ador's solutions are designed and backed by support that understands your industry inside and out.</p>

                <p>Explore proven transformer rectifier systems with us, or get in touch with our experts today for a <a href="/contact" className="trs-red-link">free consultation call</a>.</p>

                <p className="trs-hashtags">#EnergyEfficiency #PowerElectronics #Sustainability #SwitchModePowerSupply<br />#HydrogenInnovation</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="trs-bottom-row">
                <div className="trs-bottom-nav">
                  <a href="/news/top-5-mistakes-industries-make-when-buying-rectifiers-and-how-to-avoid-them" className="trs-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/next" className="trs-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="trs-share-icons">
                  <a href="#" className="trs-share-icon" aria-label="Facebook">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="#" className="trs-share-icon" aria-label="Twitter">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="#" className="trs-share-icon" aria-label="LinkedIn">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="trs-sidebar">

              {/* Recent Posts */}
              <div className="trs-sidebar-block">
                <p className="trs-sidebar-title">Recent Posts</p>
                <div className="trs-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="trs-recent-item">
                      <img src={post.img} alt={post.title} className="trs-recent-img" />
                      <div className="trs-recent-body">
                        <span className="trs-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="trs-sidebar-block">
                <p className="trs-sidebar-title">Social Media</p>
                <div className="trs-social-icons">
                  <a href="#" className="trs-social-icon" aria-label="YouTube">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="#" className="trs-social-icon" aria-label="LinkedIn">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}